import {
    CreateExpense,
    CreateInvestmentExpense,
    CreateMaintenanceExpense,
    CreateManagementExpense,
    CreateOtherSubsidizableExpense,
    CreatePersonnelExpense,
    CreateTravelExpense,
} from "./create-expense.model";
import { Expense } from "./expense.model";

export type EditExpenseAllTypes =
    | EditInvestmentExpense
    | EditOtherSubsidizableExpense
    | EditMaintenanceExpense
    | EditManagementExpense
    | EditTravelExpense
    | EditPersonnelExpense;

export class EditExpense extends CreateExpense {
    constructor(
        public readonly id: Expense["id"],
        projectId: CreateExpense["projectId"],
        typeId: CreateExpense["typeId"],
        percentageImputation: CreateExpense["percentageImputation"],
        amountImputation: CreateExpense["amountImputation"],
        paymentDate: CreateExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: CreateExpense["concept"],
        paymentInstallments?: CreateExpense["paymentInstallments"],
    ) {
        super(
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditInvestmentExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly subtypeExpense: CreateInvestmentExpense["subtypeExpense"],
        public readonly provider: CreateInvestmentExpense["provider"],
        public readonly nifProvider: CreateInvestmentExpense["nifProvider"],
        public readonly description: CreateInvestmentExpense["description"],
        public readonly invoiceNumber: CreateInvestmentExpense["invoiceNumber"],
        public readonly invoiceDate: CreateInvestmentExpense["invoiceDate"],
        public readonly expenseDate: CreateInvestmentExpense["expenseDate"],
        public readonly paymentMethod: CreateInvestmentExpense["paymentMethod"],
        public readonly taxBase: CreateInvestmentExpense["taxBase"],
        public readonly iva: CreateInvestmentExpense["iva"],
        public readonly totalTaxWithIva: CreateInvestmentExpense["totalTaxWithIva"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreateInvestmentExpense["territory"],
        public readonly isIndirectCost?: CreateInvestmentExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
        public readonly lines?: CreateInvestmentExpense["lines"],
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditOtherSubsidizableExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly provider: CreateOtherSubsidizableExpense["provider"],
        public readonly nifProvider: CreateOtherSubsidizableExpense["nifProvider"],
        public readonly description: CreateOtherSubsidizableExpense["description"],
        public readonly invoiceNumber: CreateOtherSubsidizableExpense["invoiceNumber"],
        public readonly invoiceDate: CreateOtherSubsidizableExpense["invoiceDate"],
        public readonly expenseDate: CreateOtherSubsidizableExpense["expenseDate"],
        public readonly paymentMethod: CreateOtherSubsidizableExpense["paymentMethod"],
        public readonly taxBase: CreateOtherSubsidizableExpense["taxBase"],
        public readonly iva: CreateOtherSubsidizableExpense["iva"],
        public readonly totalTaxWithIva: CreateOtherSubsidizableExpense["totalTaxWithIva"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreateOtherSubsidizableExpense["territory"],
        public readonly isIndirectCost?: CreateOtherSubsidizableExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
        public readonly lines?: CreateOtherSubsidizableExpense["lines"],
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditMaintenanceExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly subtypeExpense: CreateMaintenanceExpense["subtypeExpense"],
        public readonly provider: CreateMaintenanceExpense["provider"],
        public readonly nifProvider: CreateMaintenanceExpense["nifProvider"],
        public readonly description: CreateMaintenanceExpense["description"],
        public readonly invoiceNumber: CreateMaintenanceExpense["invoiceNumber"],
        public readonly invoiceDate: CreateMaintenanceExpense["invoiceDate"],
        public readonly expenseDate: CreateMaintenanceExpense["expenseDate"],
        public readonly paymentMethod: CreateMaintenanceExpense["paymentMethod"],
        public readonly taxBase: CreateMaintenanceExpense["taxBase"],
        public readonly iva: CreateMaintenanceExpense["iva"],
        public readonly totalTaxWithIva: CreateMaintenanceExpense["totalTaxWithIva"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreateMaintenanceExpense["territory"],
        public readonly isIndirectCost?: CreateMaintenanceExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
        public readonly lines?: CreateMaintenanceExpense["lines"],
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditManagementExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly subtypeExpense: CreateManagementExpense["subtypeExpense"],
        public readonly provider: CreateMaintenanceExpense["provider"],
        public readonly nifProvider: CreateMaintenanceExpense["nifProvider"],
        public readonly invoiceNumber: CreateMaintenanceExpense["invoiceNumber"],
        public readonly invoiceDate: CreateMaintenanceExpense["invoiceDate"],
        public readonly expenseDate: CreateMaintenanceExpense["expenseDate"],
        public readonly paymentMethod: CreateMaintenanceExpense["paymentMethod"],
        public readonly taxBase: CreateMaintenanceExpense["taxBase"],
        public readonly iva: CreateMaintenanceExpense["iva"],
        public readonly totalTaxWithIva: CreateMaintenanceExpense["totalTaxWithIva"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreateManagementExpense["territory"],
        public readonly isIndirectCost?: CreateManagementExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
        public readonly lines?: CreateManagementExpense["lines"],
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditTravelExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly subtypeExpense: CreateTravelExpense["subtypeExpense"],
        public readonly dni: CreateTravelExpense["dni"],
        public readonly name: CreateTravelExpense["name"],
        public readonly address: CreateTravelExpense["address"],
        public readonly positionFunction: CreateTravelExpense["positionFunction"],
        public readonly travelDestination: CreateTravelExpense["travelDestination"],
        public readonly dateDeparture: CreateTravelExpense["dateDeparture"],
        public readonly dateReturn: CreateTravelExpense["dateReturn"],
        public readonly transport: CreateTravelExpense["transport"],
        public readonly otherTransport: CreateTravelExpense["otherTransport"],
        public readonly amount: CreateTravelExpense["amount"],
        public readonly kilometers: CreateTravelExpense["kilometers"],
        public readonly costPerKilometer: CreateTravelExpense["costPerKilometer"],
        // Campos específicos para ACCOMMODATION_MEALS
        public readonly position: CreateTravelExpense["position"],
        public readonly travel: CreateTravelExpense["travel"],
        public readonly startDate: CreateTravelExpense["startDate"],
        public readonly endDate: CreateTravelExpense["endDate"],
        public readonly diet: CreateTravelExpense["diet"],
        public readonly days: CreateTravelExpense["days"],
        public readonly expensePersonDay: CreateTravelExpense["expensePersonDay"],
        public readonly totalExpense: CreateTravelExpense["totalExpense"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreateTravelExpense["territory"],
        public readonly isIndirectCost?: CreateTravelExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
        public readonly lines?: CreateTravelExpense["lines"],
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}

export class EditPersonnelExpense extends EditExpense {
    // eslint-disable-next-line max-params
    constructor(
        id: EditExpense["id"],
        projectId: EditExpense["projectId"],
        typeId: EditExpense["typeId"],
        public readonly name: CreatePersonnelExpense["name"],
        public readonly dni: CreatePersonnelExpense["dni"],
        public readonly contractStartDate: CreatePersonnelExpense["contractStartDate"],
        public readonly contractEndDate: CreatePersonnelExpense["contractEndDate"],
        public readonly contractType: CreatePersonnelExpense["contractType"],
        public readonly weeklyHours: CreatePersonnelExpense["weeklyHours"],
        // public readonly professionalGroupExp: Nullable<ProfEnum>,
        public readonly contributionGroup: CreatePersonnelExpense["contributionGroup"],
        public readonly month: CreatePersonnelExpense["month"],
        public readonly daysImputable: CreatePersonnelExpense["daysImputable"],
        public readonly netSalary: CreatePersonnelExpense["netSalary"],
        public readonly irpf: CreatePersonnelExpense["irpf"],
        public readonly socialSecurity: CreatePersonnelExpense["socialSecurity"],
        public readonly monthlyGrossIncome: CreatePersonnelExpense["monthlyGrossIncome"],
        public readonly companySocialSecurity: CreatePersonnelExpense["companySocialSecurity"],
        public readonly totalCost: CreatePersonnelExpense["totalCost"],
        percentageImputation: EditExpense["percentageImputation"],
        amountImputation: EditExpense["amountImputation"],
        paymentDate: EditExpense["paymentDate"],
        documents: CreateExpense["documents"],
        concept?: EditExpense["concept"],
        paymentInstallments?: EditExpense["paymentInstallments"],
        public readonly territory?: CreatePersonnelExpense["territory"],
        public readonly isIndirectCost?: CreatePersonnelExpense["isIndirectCost"],
        public readonly projectFinantialEntityId?: number | null,
    ) {
        super(
            id,
            projectId,
            typeId,
            percentageImputation,
            amountImputation,
            paymentDate,
            documents,
            concept,
            paymentInstallments,
        );
    }
}
